import { media } from '@platform-ui/constants';
import { throttle } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import useNextTick from '../../../../hooks/useNextTick';
import { notifyIframeHeight } from '../../../../utils/notifyIframeHeight';
import { MatrixViewModes } from './MatrixWrapper';

const PHONE_BREAKPOINT = media.PHONE_GIANT;

export const useMatrixViewMode = () => {
  const [viewMode, setViewMode] = useState<MatrixViewModes>(() => {
    if (document.body.offsetWidth < PHONE_BREAKPOINT) return 'compact';
    return 'default';
  });

  const matrixRef = useRef<HTMLDivElement>(null);

  const nextTick = useNextTick();

  useEffect(() => {
    nextTick(notifyIframeHeight);
  }, []);

  useEffect(() => {
    const matrix = matrixRef.current;

    let overflowWidth: number | null = null;

    if (!matrix) {
      return;
    }

    const handleResize = throttle(() => {
      const { offsetWidth, scrollWidth } = matrix;

      const isPhone = offsetWidth < PHONE_BREAKPOINT;
      const isOverflow = scrollWidth > offsetWidth;

      const isAboveOverflowWidth = overflowWidth ? offsetWidth > overflowWidth : true;

      if (isOverflow) {
        overflowWidth = offsetWidth;
      }

      // eslint-disable-next-line no-console
      console.log(
        'offsetWidth',
        offsetWidth,
        'scrollWidth',
        scrollWidth,
        'bodyWidth',
        document.body.offsetWidth,
        'isPhone',
        isPhone,
        'isOverflow',
        isOverflow,
        'isAboveOverflowWidth',
        isAboveOverflowWidth,
      );
      setViewMode(type => {
        if (!isPhone && !isOverflow && isAboveOverflowWidth) {
          return 'default';
        }

        if (type === 'default') {
          return 'compact';
        }

        if (type === 'compact' && isOverflow) {
          return 'question';
        }

        if (type === 'question' && !isOverflow && isAboveOverflowWidth) {
          return 'compact';
        }

        return type;
      });
    }, 100);

    const observer = new ResizeObserver(handleResize);

    observer.observe(matrix);

    return () => {
      observer.disconnect();
    };
  }, []);

  return { matrixRef, viewMode };
};
